import { H2RInput } from "../../imports";

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<>
			<H2RInput
				label={`Colour`}
				value={cue.colour}
				colourPicker={true}
				onChange={(value) => {
					onUpdate({ colour: value });
				}}
			/>
		</>
	);
};

export const GraphicCueContent = ({ cue, twoLines }) => {
	return (
		<div
			className={`overflow-ellipsis w-48 md:w-auto max-w-xs md:max-w-sm lg:max-w-lg overflow-hidden
            ${twoLines ? "whitespace-normal max-h-10" : "whitespace-nowrap"}
            `}
		>
			<span className="font-semibold">
				{cue?.colour || "No colour selected"}
			</span>
		</div>
	);
};
